var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSetaR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.317383 6.21055C0.317383 6.67999 0.697941 7.06055 1.16738 7.06055L14.4448 7.06055C14.9143 7.06055 15.2948 6.67999 15.2948 6.21055C15.2948 5.7411 14.9143 5.36055 14.4448 5.36055L1.16738 5.36055C0.697941 5.36055 0.317383 5.7411 0.317383 6.21055Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5279 11.7906C10.8598 12.1225 11.398 12.1225 11.7299 11.7906L16.0248 7.49571C16.7473 6.77324 16.7473 5.60188 16.0248 4.87941L11.7496 0.604244C11.4177 0.272298 10.8795 0.272298 10.5475 0.604244C10.2156 0.936189 10.2156 1.47438 10.5475 1.80633L14.8227 6.0815C14.8813 6.14007 14.8813 6.23505 14.8227 6.29363L10.5279 10.5885C10.1959 10.9204 10.1959 11.4586 10.5279 11.7906Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetaR);
export default __webpack_public_path__ + "static/media/icon_seta_r.a7e0d88278f78e812ea440394979f8f2.svg";
export { ForwardRef as ReactComponent };